module.exports = __webpack_public_path__ + "static/media/serieXV.9ac08f88.pdf";